<template>
  <div class="appbox" :class="{'in-box':isIndex,'rank':isRank}">
    <sharecss></sharecss>
    <router-view :key="key"></router-view>
  </div>
</template>

<script>
  import ShareCss from './js/openjs/uph5/sharestyle.vue';
  import url from './js/plug/url';
  export default {
    name: 'App',
    components:{
      "sharecss": ShareCss
    },
    computed: {
      key() {
        return this.$route.name !== undefined? this.$route.name +new Date(): this.$route +new Date()
      },
      isIndex(){
        if(this.$route.name === "Index") return true;
        else return false;
      },
      isRank(){
        if (this.$route.name === "Rank") {
          $('body').addClass("rank-body");
          return true;
        } else {
          $('body').removeClass("rank-body");
          return false;
        }
      },
    },
    mounted() {
      let hash = UpSDK.cache.getCache('redirectHash');
      let currentHash = window.location.hash.substring(1);

      if (hash){
          UpSDK.cache.removeCache('redirectHash');

          if (hash && hash !== currentHash) {
            this.$router.push(hash);
          }
      }
      if (url.query('ivtmore') == 1) {
        // let target = url.delQuery(location.href, 'ivtmore') + 'ivtmore';
        // location.replace(target);
        this.$router.push('ivtmore')
      } else if (url.query('betrank') == 1) {

        this.$router.push('rank');
      }
    }
  }
</script>

<style>
  * {
    user-select: none;
  }
  body {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    background: url("./image/bg-bot.jpg") repeat-y #032603 center top; 
    background-size: 100% 100%;
  }
  body.pcmode {
    background-size: 20rem auto;
  }
  a,a:link,a:hover,a:visited{text-decoration: none; color: inherit;}
  .appbox{ position: relative;  z-index: 1;min-height: 100%; }
  body.areg{ direction: rtl;}
  .flex-view{ display: flex; flex-direction: column;}
  .flex-box{ display: -webkit-box; display: flex;}
  .flex-align{ display: -webkit-box; display: flex; -webkit-align-items: center; align-items: center;}
  .flex-c{ display: -webkit-box; display: flex; -webkit-align-items: center; align-items: center;  -webkit-justify-content: center; -webkit-box-pack:center; justify-content: center;}
  .flex-w{ flex: 1;}
  .tc{ text-align: center; -webkit-justify-content: center; -webkit-box-pack: center; justify-content: center;}
  .tr{ justify-content: flex-end; text-align: right;}
  .vm{ -webkit-align-items: center; align-items: center; vertical-align: middle;}
  /*.txt-upp{ text-transform: uppercase;}*/
  .mr3{ margin-right: 0.09375rem;}
  .ml5{ margin-left: 0.15625rem;}
  .mr11{ margin-right: 0.34375rem;}
  .areg .mr3{ margin-left: 0.09375rem; margin-right: 0;}
  .areg .mr11{ margin-left: 0.34375rem; margin-right: 0;}
  .bg-top{ position: absolute; left: 0; right: 0; top:0; width: 100%; height: 5.09375rem; z-index: 1;}
  .cont{ min-height: 100%; width: 100%;  background: url("./image/bg-idx.jpg") no-repeat; background-size: 100% auto;}
  .recordbox, .record-detail {
    background: url("./image/bg-er.jpg") no-repeat; 
    background-size: 100% auto;
  }
  header{ position: relative; height: 1rem; padding: 0 0.25rem; background: linear-gradient(rgba(69,101,195,.8),rgba(40,74,180,.8)); color: #fff; font-size: 0.3125rem; z-index: 1; box-sizing: border-box; align-items: center;}
  .navtop {line-height: 1;}
  .tit{ font-size: 0.4375rem; font-weight: 700; text-align: center; flex: 1.3;}
  .pcmode .tit {
    font-size: 0.5rem;
  }
  .txt-upp{ /*text-transform: uppercase;*/}
  /*.txt-upp span { margin: 0 0.09375rem; }*/
  .vs{ display: block; width: 0.96875rem; height: 0.96875rem; margin: 0 0.09375rem; background: url("./image/vs.png") no-repeat; background-size: 100% 100%;}
  .s-win{ color: #fbfe01!important;}
  .s-send{ color: #ff8a00!important;}
  .s-back{ color: #60ff00!important;}
  [class^="ico-"]{ display: block; width: 0.5rem; height: 0.5rem;}
  .ico-gto{background: url("./image/ico-gto.png") no-repeat; background-size: 0.5rem 0.5rem;}
  .ico-eth{background: url("./image/ico-eth.png") no-repeat; background-size: 0.5rem 0.5rem;}
  .ico-u{background: url("./image/ico-u.png") no-repeat; background-size: 0.5rem 0.5rem;}
  .tip-box{ flex-direction: column; flex: 1; position: relative; height: 100%; z-index: 2;}
  .tip-box.idx-n-match{ height: 70%;}
  .ball{ display: block; width: 4.6875rem; height: 3.96875rem;}
  .p-txt{ margin-top: 0.15625rem; font-size: 0.375rem; font-weight: 700; color: #037100; text-align: center;}
  .p-btn{padding: 0 0.3125rem; height: 0.90625rem; margin-top: 0.46875rem; line-height: 0.90625rem; background: #fde100; font-size: 0.40625rem; font-weight: 700; color: #025914; text-align: center; border-radius: 0.15625rem;}
  /*tips提示框*/
  .et-box{position:fixed; top: 0; bottom:0; left:0; display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%; text-align: center; font-size: 0.4375rem; color: #fff; z-index: 999;}
  .et-cont{ display: inline-block; width: auto; padding: 0.375rem; background: rgba(0,0,0,.8); border-radius: 0.25rem;}
  /*tip-loading动画*/
  .tip-load-b{ position: fixed; top: 0; right: 0; bottom: 0; left: 0; display: -webkit-box;  display: flex; -webkit-align-items: center; align-items: center; -webkit-justify-content: center; -webkit-box-pack: center; justify-content: center; z-index: 5;}
  .tip-load{ display: -webkit-box; display: flex; -webkit-align-items: center; align-items: center; -webkit-justify-content: center; -webkit-box-pack: center; justify-content: center; width: 1.25rem; height: 1.25rem; background: #999; border-radius: 0.15625rem;}
  .load-ico{ display: block; height: 0.46875rem; width: 0.46875rem; border-radius: 100%; border: 0.09375rem solid #bdffb4; border-top-color: transparent; border-bottom-color: transparent; vertical-align: middle; -webkit-animation: rotate 0.75s linear infinite; animation: rotate 0.75s linear infinite;}
  /*弹窗*/
  .popup{ position: fixed; top: 0; right: 0; bottom: 0; left: 0; z-index: 99;}
  .mask{ position: fixed; top:0; right: 0; bottom: 0; left: 0; background: rgba(0,0,0,.8);}
  .pop-box{ position: fixed; width: 90%; height: 100%; display: flex; left: 50%; transform: translateX(-50%); align-items: center; flex: 1; box-sizing: border-box;}
  .pcmode .pop-box {

  }
  .pop-cont-box{ position: absolute; display: flex; width: 100%; min-height: 3.59375rem; max-height: 80%; background: #fff; border-radius: 0.28125rem; box-sizing: border-box; top: 50%; transform: translateY(-50%);}
  .pcmode .pop-cont-box {
    width: 13.75rem;
    margin-left: -6.875rem;
    left: 50%;
  }
  .pop-cont{ flex: 1; overflow: auto;-webkit-overflow-scrolling: touch;}
  .close-ico{ position: absolute; top: 0.15625rem; right: 0.125rem; width: 0.625rem; height: 0.625rem; background: url("./image/close.png") no-repeat; background-size: 100% 100%; z-index: 5;}
  .areg .close-ico {
    right: auto;
    left: 0.125rem;
  }
  .p-c-box{ padding: 0 0.40625rem; font-size: 0.34375rem;}
  .r-tit{ margin: 0.46875rem 0; font-size: 0.4375rem; font-weight: 700; color: #0e5200;}
  .bind-box .r-tit{ margin: 0.46875rem 0 0.25rem;}
  .r-tit .line-ico{ margin: 0 0.25rem;}
  /*筛选和切换语言弹窗*/
  .sct-cont{ padding: 0 0.25rem 0.34375rem;}
  .sct-h{ align-items: center; padding-bottom: 0.375rem; border-bottom: 0.03125rem solid #dcdcdc; color: #0e5200; font-size: 0.34375rem;}
  .sct-h .sct-h-desc {line-height: 1;}
  .check-btn{ display: block; min-width:1.59375rem; padding: 0.15625rem 0.03125rem; margin-right: 0.53125rem; line-height: 1; background: #f0f0f0; text-align: center; border-radius: 0.25rem; box-sizing: border-box;}
  .m-sct-box{ overflow: auto; font-size: 0.34375rem; color: #032b00;}
  .lang-box .m-cell{ width: auto; padding: 0.15625rem;}
  .lang-box .m-sct-box{ padding-bottom: 0.625rem;}
  .m-cell{ float: left; display: block; min-width: 1.6875rem; padding: 0.15625rem 0.03125rem; margin: 0.4375rem 0.3125rem 0 0; line-height: 1; border: 0.03125rem solid #032d01; text-align: center; border-radius: 0.25rem; box-sizing: border-box;}
  .m-cell.active{ color: #138100; background: #fde100;}
  .m-btn{ display: block; width: 3.3125rem; height: 0.90625rem; margin-top: 0.5rem; margin-bottom: 0.34375rem; line-height: 0.90625rem; text-align: center; background: #46d40f; color: #0c4702; font-size: 0.40625rem; font-weight: 700; border-radius: 0.25rem;}
  /*邀请*/
  @-webkit-keyframes rotate {
    0% {
      transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
      -webkit-transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
    }
  }
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue